<template>
    <div class="row" v-if="couponList != null">
      <div class="col-lg-12">
        <div class="form-box">
          <div class="form-title-wrap">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="title">İade</h3>
            </div>
          </div>
          <div class="form-content pb-2">

            <h3 class="title">Kupon Listesi</h3>
            <p class="font-size-14">{{ couponList.length }} listeleniyor</p>

            <div class="table-form table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th scope="col">id</th>
                  <th>amount</th>
                  <th>status</th>
                  <th>createReason</th>
                  <th>Kullanılan Rezervasyon</th>
                  <th>Kullanım Tarihi</th>
                  <th>Üretiliş Tarihi</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="coupon in couponList">
                  <th scope="row">{{ coupon.id }}</th>
                  <th>{{ coupon.amount }} | toCurrency</th>
                  <th><reservation-status :booking-status="coupon.status"></reservation-status></th>
                  <td>{{ coupon.createReason }}</td>
                  <th><a v-if="coupon.usedBookingId !== 0" :href="basePath+'/bookings/'+coupon.usedBookingId">#{{coupon.usedBookingId}}</a></th>
                  <td v-if="coupon.useDate !== null">{{ coupon.useDate | ddMMyyyyHHmmSS }}</td>
                  <td v-if="coupon.useDate === null"> Aktif </td>
                  <td>{{ coupon.createDate | ddMMyyyyHHmmSS }}</td>
                  <td>
                    <div v-if="coupon.status === 'NOT_USED'" class="table-content" @click="showUseCouponPopup(coupon.id)">
                      <a class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                        <i class="la la-edit"></i>
                      </a>
                    </div>
                  </td>

                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ReservationStatus from "../common/ReservationStatus";
export default {
  name: "couponList",
  components: {ReservationStatus},
  computed:{
    couponList:{
      get(){
        return this.$store.getters.getCouponList
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods:{
    showUseCouponPopup(couponId){
      this.$store.commit("setCouponId", couponId);
      $("#showUseCouponPopUp").modal("show");
    },
  },
}
</script>

<style scoped>

</style>